import React, { useEffect, useState } from "react";
import "./recommendedBooks.scss";
import { ReferenciaContenido } from "../../../interfaces/ReferenciaContenido";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { getBooks } from "../../../services/books";
import CardBook from "../../atoms/card-book/card-book";
import Loading from "../../atoms/loading/loading";
import { normalizeTwoWords } from "../../../shared/utils/stringUtilities";
const RecommendedBooks = (props: ReferenciaContenido) => {
  const data = props;
  const [results, setResults]: Array<any> = useState([]);
  const [loaded, setLoaded] = useState(false);
  const { nombreCategoria } = props;
  const component = (dots) => {
    return (
      <div style={{ bottom: "-10px" }}>
        <ul>{dots}</ul>
      </div>
    );
  };

  const setting = {
    dots: true,
    arrows: false,
    infinite: false,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    initialSlide: 0,
    appendDots: (dots) => component(dots),
    responsive: [
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1.5,
          slidesToScroll: 1,
          infinite: false,
          dots: false,
        },
      },
    ],
  };

  useEffect(() => {
    getBooks(
      JSON.parse(data?.descripcion?.raw)?.content[0]?.content[0]?.value
    ).then((res) => {
      setResults(res);
      setLoaded(true);
    });
  }, []);

  const renderBooks = () => {
    const auxArray: any[] = [];
    results.data.data.filter.map((elem, idx) => {
      const book = {
        titulo: elem.titulo,
        origenContenido: "origen",
        autor: elem.autor,
        image: elem.image,
        mmsId: elem.mmsId,
        tipoContenido: elem.tipoContenido,
      };
      auxArray.push(
        <CardBook
          book={book}
          key={`book ${idx}`}
          gtmClass={`gtmRedDeAmor${normalizeTwoWords(
            nombreCategoria
          )}Libros${normalizeTwoWords(elem?.titulo)}`}
        />
      );
    });
    return auxArray;
  };

  return (
    <div className="m-books">
      <div className="center">
        <div className="m-books__head">
          <div className="m-books__head__title">
            <h2>{data.tituloGeneral}</h2>
          </div>
          <div className="m-books__head__show-everything">
            <a href={data?.redireccionBoton} target="_blank" rel="noreferrer">
              {data?.tituloBoton}
            </a>
          </div>
        </div>
      </div>

      <div className="center hide-on-mobile">
        <div className="m-books__container">
          {!loaded ? <Loading /> : renderBooks()}
        </div>
      </div>
      <div className="m-books__container show-on-mobile">
        <Slider {...setting}>{!loaded ? <Loading /> : renderBooks()}</Slider>
      </div>
    </div>
  );
};

export default RecommendedBooks;
